import { useState } from 'react';

import { analyticsCreateRider } from '../api/services/Analytics';
import { validateRiderDetails } from '../api/services/Riders';

export const useRiderValidation = () => {
  const [isFetching, setIsFetching] = useState(false);

  const validate = async (data: Partial<RiderFormType>) => {
    setIsFetching(true);
    const response = await validateRiderDetails(data);

    if (response.type === 'error') {
      const errors = response.data?.errors ? mergeErrors(response.data.errors) : '';

      analyticsCreateRider({
        ...(data.category && { category: data.category }),
        ...(data.photosAttributes && { hasPhoto: !!data.photosAttributes[0]?.attachment?.name }),
        ...(data.mobilePhoneNumber && { hasPhone: !!data.mobilePhoneNumber }),
        ...(data.isSharedBillingRider && { isShared: !!data.isSharedBillingRider }),
        ...(data.passengersContactsAttributes && {
          numCareGivers: data.passengersContactsAttributes.filter((c) => c.role === 'caregiver').length,
          numEContacts: data.passengersContactsAttributes.filter((c) => c.role === 'emergency_contact').length,
        }),
        ...(data.email && data.firstName && { hasEmail: !!data.email }), // this is to help distinguish between rider and caregiver email
        ...(errors && { errorValidation: errors }),
      });
    }
    setIsFetching(false);

    return response;
  };

  return {
    validateRiderDetails: validate,
    isFetching,
  };
};

function mergeErrors(errorsObj: { [key: string]: string | { [key: string]: string } }) {
  const errors: string[] = [];

  try {
    Object.keys(errorsObj).forEach((key) => {
      const value = errorsObj[key];

      if (typeof value === 'object') {
        Object.keys(value).forEach((subKey) => {
          errors.push(`${subKey} ${value[subKey]}`);
        });
      } else if (typeof value === 'string') {
        errors.push(`${key} ${value}`);
      }
    });
  } catch {
    // this is a safety in case the API returns something unexpected
  }

  return errors;
}
